import React, { useEffect } from 'react'
// import styled from 'styled-components'
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
// import { RouteComponentProps, useHistory } from "react-router-dom";
import { IAppState } from '../../db/reducers';
import { Table, TableHead, TableBody, TableFooter,TableRow, TableCell, TableContainer, TablePagination } from '@material-ui/core';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import TablePaginationActions from './TablePaginationActions'
import AdminButtons from './AdminButtons'
import styled from 'styled-components';

const SAdminPollTable = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  width: 75vw;
  height: 60vh;
`

const theme = createMuiTheme({
  overrides: {
    // Style sheet name ⚛️
    MuiTableContainer: {
      root: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
      }
    },
    MuiTablePagination: {
      // Name of the rule
      root: {
        alignItems: 'right',
        justifyContent: 'flex-end'
      },
      toolbar: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '70vw'
      }
    },
  },
});

interface IPoll {
  name: string;
  owner: string;
  scores: {
    [scoreId: string]: string; // scoreId is a timestamp,
  };
}

interface RowDef {
  id: string;
  numberParts: number;
  avgScore: string;
}

interface IAdminPollTableProps {
  polls: IPoll[];
  setShowDeleteWindow(st8: boolean): void;
  setCurrentPollId(pollId: string): void;
}


const AdminPollTable: React.FunctionComponent<IAdminPollTableProps> = (props)  => {
  const { polls, setShowDeleteWindow, setCurrentPollId } = props
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([{
    id: '',
    numberParts: 0,
    avgScore: '0'
  }]);
  const rowsPerPage= 10

  useEffect(() => {
    let mappedRows: RowDef[] = [];

    if (!polls || polls.length < 1) { 
      mappedRows = [] 
    } else {
      mappedRows = polls.map((poll: IPoll) => {
        const scoresLength: number = poll.scores ? Object.keys(poll.scores).length : 0;
  
        const scoresAvg: number = poll.scores
          ? (Object.keys(poll.scores).reduce(
          (pre: number, key: string) => pre + parseFloat(poll.scores[key]),
          0) / scoresLength)
          : 0;
  
        return {
          id: poll.name,
          numberParts: scoresLength,
          avgScore: scoresAvg.toFixed(1)
        }
      })
    }
  
    setRows(mappedRows)
  }, [polls])
  
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };
  
  

  return (
    <SAdminPollTable className={'SAdminPollTable'}>
      <ThemeProvider theme={theme}>
        <TableContainer>
          <Table size={"small"}>

            <TableHead>
              <TableRow>
                <TableCell align={"left"} style={{fontSize: 'larger'}}>Poll Name</TableCell>
                <TableCell align={"center"} style={{fontSize: 'larger'}}>No. Participants</TableCell>
                <TableCell align={"center"} style={{fontSize: 'larger'}}>Average Score</TableCell>
                <TableCell align={"right"} style={{fontSize: 'larger'}}></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {
                (rowsPerPage > 0
                  ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : rows
                ).map((row) => (
                  <TableRow key={row.id}>
                    <TableCell align={"left"} style={{fontSize: 'larger'}} component="th" scope="row">
                      {row.id}
                    </TableCell>
                    <TableCell align={"center"} style={{fontSize: 'larger'}}>{row.numberParts}</TableCell>
                    <TableCell align={"center"} style={{fontSize: 'larger'}}>{row.avgScore}</TableCell>
                    <TableCell align={"right"} padding={"none"}>
                      <AdminButtons pollId={row.id} setShowDeleteWindow={setShowDeleteWindow} setCurrentPollId={setCurrentPollId} />
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  className={"TablePagination"}
                  colSpan={4}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                  }}
                  labelRowsPerPage={"Rows / Page: "}
                  rowsPerPageOptions={[10]}
                  onChangePage={handleChangePage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </ThemeProvider>
    </SAdminPollTable>
  )
}


const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AdminPollTable)